// 0 预分配完成  1 1单多件待处理 2 处理发货中
// 3 已被拆单情况  4 手动操作取消 5 长时间未处理自动取消 6 异常取消
// 7 同步时退款 8 异常多发（实际未发） 9 其他
// 10 同步物流成功 11 同步物流异常 12 可换快递 13 调度单拦截
// 20 （通过订单管理页面）手动发货成功 21 补打面单成功 22 自由打单成功
// 23 预先获取面单，实际未发货 24 工单打印成功
// 25 非履约客户手动打单 26 非履约客户补打面单 27 非履约客户自由打单
// 28 提前获取面单并同步物流，未真实发货 29-提前获取面单，且已发货 30-提前获取面单，改发礼品

const map = {
    0: '预分配完成',
    1: '一单多件待处理',
    2: '处理发货中',
    3: '已被拆单',
    4: '手动取消',
    5: '为处理自动取消',
    6: '异常取消',
    7: '同步时退款',
    8: '异常多发(实际未发)',
    9: '其他',
    10: '同步物流成功',
    11: '同步物流异常',
    12: '可换快递',
    13: '调度单拦截',
    20: '手动发货成功',
    21: '补打面单成功',
    22: '自由打单成功',
    23: '提前获取面单，实际未发货',
    24: '工单打印成功',
    25: '非履约客户手动打单',
    26: '非履约客户补打面单',
    27: '非履约客户自由打单',
    28: '提前获取面单并同步物流，未真实发货',
    29: '提前获取面单，且已发货',
    30: '提前获取面单，改发礼品'
}

const getActionStatusMap = () => {
    let mapCpy = {}
    for (let key in map) {
        if (map.hasOwnProperty(key))
            mapCpy[key] = map[key]
    }
    return mapCpy
}

export default {
    getActionStatusMap
}


// WEBPACK FOOTER //
// ./src/utils/actionStatusUtils.js